import React from 'react'
import LoginForm from '../../../components/MainComponents/LoginForm/LoginForm'
export default function Login() {
  return (
    <>
    <LoginForm />
    </>
  )
}

